import * as React from 'react';

import type {SortDirection} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsAscIcon} from 'shells/icon/svg/arrows-asc-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsDescIcon} from 'shells/icon/svg/arrows-desc-icon';

import {getIconForActivityType} from '../../../setup/activity-types/helpers';

import {SORT_DIRECTION_ASCENDING, SORT_DIRECTION_DESCENDING} from '../constants';

import styles from './activity-report-summary-table.module.css';

type Props = {
    title: string;
    style?: any;
    onClick?: () => void;
    sortDirection: SortDirection | null | undefined;
    iconType: number | null | undefined;
};

export const ActivityTableHeaderCell = (props: Props) => {
    let sortArrow;
    if (props.sortDirection === SORT_DIRECTION_ASCENDING)
        sortArrow = <ArrowsAscIcon wrapWithDiv={false} size={16} fill={colors.blue} />;
    if (props.sortDirection === SORT_DIRECTION_DESCENDING)
        sortArrow = <ArrowsDescIcon wrapWithDiv={false} size={16} fill={colors.blue} />;

    const Icon = props.iconType != null && getIconForActivityType(props.iconType);

    return (
        <div
            style={props.style}
            title={props.title}
            onClick={props.onClick}
            className={styles['activity-type']}
        >
            <div className='flex gap-8 align-center truncate'>
                {Icon && NutClientConfig.hasActivityReportExpansionFF && (
                    <Icon
                        size={13}
                        color={colors.grey}
                        style={{color: colors.grey}}
                        className='flex align-center'
                    />
                )}
                <div className='truncate'>{props.title}</div>
            </div>
            <div className='flex-shrink'>{sortArrow}</div>
        </div>
    );
};
